<template>
  <v-row id="bookingHome" justify="center" class="ma-0">
    <v-col cols="12" xs="11" sm="10" md="8" lg="8" xl="8">
      <v-card flat color="transparent">
        <BookingOrder
          v-if="currentComponent === 'Order'"
          :eventDetails="eventDetails"
          @back="onOrderBack"
          @continue="onOrderContinue"
        />
        <BookingOrderEmail
          v-if="currentComponent === 'BookingDetailsEmail'"
          @back="onOrderEmailBack"
          @continue="onOrderEmailContinue"
        />
        <BookingOrderAccount
          v-if="currentComponent === 'BookingDetailsAccount'"
          @back="onOrderAccountBack"
          @continue="onOrderAccountContinue"
        />
        <BookingDetailsProducts
          v-if="currentComponent === 'BookingDetailsProducts'"
          :userEmail="userEmail"
          @back="onProductsBack"
          @continue="onProductsContinue"
          @openOrderOverview="openOrderOverview"
        />
        <BookingOrderOverview
          v-if="currentComponent === 'OrderOverview'"
          :allOrders="allOrders"
          @back="onOverviewBack"
        />
        <BookingUserDetails
          v-if="currentComponent === 'UserDetails'"
          @back="onUserDetailsBack"
          :orderData="orderData"
          :eventDetails="eventDetails"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { scrollToElement } from '@/shared/utility';
import BookingDetailsProducts from './Booking_Details_Products.vue';
import BookingOrder from './Booking_Order.vue';
import BookingUserDetails from './Booking_UserDetails.vue';
import BookingOrderOverview from './Booking_Order_Overview.vue';
import BookingOrderEmail from './Booking_Order_Email.vue';
import BookingOrderAccount from './Booking_Order_Account.vue';

export default {
  name: 'Booking',
  components: {
    BookingDetailsProducts,
    BookingOrder,
    BookingUserDetails,
    BookingOrderOverview,
    BookingOrderEmail,
    BookingOrderAccount,
  },
  beforeDestroy() {
    // show the header and footer if you leave the page
    this.$store.commit('setHideHeaderAndFooter', false);
  },
  data() {
    return {
      userEmail: '',
      userDetails: '',
      errorText: '',
      errorDialog: false,
      orderData: {},
      allOrders: [],
      currentComponent: 'Order',
    };
  },
  computed: {
    ...mapGetters({
      orders: 'shoppingCart/orders',
      eventDetails: 'shoppingCart/eventDetails',
    }),
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    onOrderContinue(allOrders) {
      if (this.$store.getters['auth/userName'] !== '') {
        this.currentComponent = 'BookingDetailsProducts';
      } else {
        this.currentComponent = 'BookingDetailsEmail';
      }

      this.allOrders = allOrders;
      this.scrollToTop();
    },
    onOrderBack() {
      this.$router.go(-1);
    },
    onOrderEmailContinue(userEmail) {
      this.currentComponent = 'BookingDetailsAccount';
      this.userEmail = userEmail;
      this.scrollToTop();
    },
    onOrderEmailBack() {
      this.currentComponent = 'Order';
    },
    onOrderAccountContinue() {
      this.currentComponent = 'BookingDetailsProducts';
      this.scrollToTop();
    },
    onOrderAccountBack() {
      this.currentComponent = 'BookingDetailsEmail';
    },
    onProductsContinue(orderData) {
      this.orderData = orderData;
      this.currentComponent = 'UserDetails';
      this.scrollToTop();
    },
    onProductsBack() {
      if (this.$store.getters['auth/userName'] !== '') {
        this.currentComponent = 'Order';
      } else {
        this.currentComponent = 'BookingDetailsAccount';
      }
      this.scrollToTop();
    },
    openOrderOverview() {
      this.currentComponent = 'OrderOverview';
      this.scrollToTop();
    },
    onOverviewBack() {
      this.currentComponent = 'BookingDetailsProducts';
    },
    onUserDetailsBack() {
      this.currentComponent = 'BookingDetailsProducts';
    },
    scrollToTop() {
      scrollToElement('#bookingHome');
    },
  },
};
</script>
